<template>
  <div class="iv-clean-certification">
    <ApplyStep :stepData="stepData" />
    <div class="iv-main-width iv-p-b-40 iv-p-t-24">
      <h1 class="iv-main-color iv-fs-24 iv-fc-85 iv-vertical-line">廉洁证明申请</h1>
      <FormLayout
        ref="FormLayout"
        :readOnly="true"
        :model="formItem"
        :list="formList">
      </FormLayout>
      <LayoutTitle title="申请名单">
        <DragTable
          class="iv-m-t-24"
          noSearch 
          :showSelect="false"
          :showPage="false"
          :showEdit="false"
          :showDelete="false"
          ref="DragTable" 
          :immediateForce="true" 
          :columns="columns" 
          :tableData="tableData">
        </DragTable>
      </LayoutTitle>
      <FooterOperator>
        <Button type="back" class="uit-back iv-pointer" @click="onBack">
          <span>返回</span>
        </Button>
      </FooterOperator>
    </div>
  </div>
</template>

<script>
import ApplyStep from '../components/apply-step.vue'
import LayoutTitle from '@/components/layout/layout-title'
import FormLayout from '@/components/layout/form'
import DragTable from '@/components/drag-table-inline'
import FooterOperator from '@/components/footer-operator'
import allInfo from './allinfo.js'
import columns from './columns.js'
import { timeFormat } from '@/utils'

export default {
  name: 'certificationFeedback',
  data () {
    return {
      stepData: [{
        step: 1,
        status: 'complete',
        title: '廉洁证明申请'
      },
      {
        step: 2,
        status: 'complete',
        title: '接收申请'
      },
      {
        step: 3,
        status: 'complete',
        title: '开具廉洁证明情况'
      },
      {
        step: 4,
        status: 'complete',
        title: '领导审核'
      },
      {
        step: 5,
        status: 'ongoing',
        title: '廉洁证明反馈'
      }],
      formList: [],
      formItem: {},
      columns: [],
      tableData: [],
      dictMap: {},
      fileId: '',
      certificateId: ''
    }
  },
  async created () {
    this.rules = {}
    this.certificateId = this.$decode(this.$route.query.certificateId)
    this.getCodeTable('DM14') // 性别
    this.getCodeTable('GB4762') // 政治面貌
    this.getCodeTable('DM16') // 学历
    this.getCodeTable('KZ27') // 行政职务
    await this.getCodeTable('KZ41') // 是 or 否
    await this.getCodeTable('BOE51') // 廉洁问题类型
    this.getCertificate()
    this.getCertificateUser()
    this.formList = allInfo.call(this)
    this.columns = columns.call(this)
  },
  methods: {
    // 查看廉洁证明详情
    getCertificate () {
      this.$ajax({
        url: 'api-platform/honest/certificate/get',
        method: 'GET',
        data: {
          certificateId: this.certificateId
        }
      }).then(({data}) => {
        this.formItem = data.data
        this.formItem.applyDate = timeFormat(this.formItem.applyDate, 'yyyy-MM-dd')
        // 廉洁无问题证明文件模板
        if (this.formItem.fileId) {
          this.fileId = this.formItem.fileId
          this.getActivityFiles(this.fileId).then(data => {
            this.$set(this.formItem, 'certificateFile', data)
          })
        } else {
          this.fileId = this.getUuid()
        }
      })
    },
    // 查看廉洁证明名单详情
    getCertificateUser () {
      this.$ajax({
        url: 'api-platform/honest/certificate/getCertificateUserList',
        method: 'GET',
        data: {
          certificateId: this.certificateId
        }
      }).then(({data}) => {
        this.tableData = data.data
      })
    },
    // 返回
    onBack () {
      this.$router.go(-1)
    },
    // 获取数据字典
    // 获取数据字典
    getCodeTable (code) {
      this.$set(this.dictMap, code, [])
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: this.bizLineCode || 'YWX01'
          }
        }).then(({data}) => {
          this.dictMap[code] = data.data.map(item => ({
            label: item.title,
            value: item.value
          }))
          resolve()
        })
      })
    }
  },
  components: {
    ApplyStep,
    LayoutTitle,
    FormLayout,
    DragTable,
    FooterOperator
  }
}
</script>

<style lang="scss" scoped>
@import "variable/variable.scss";

.iv-clean-certification {
  .iv-green-color {
    color: greenyellow
  }
  .iv-vertical-line::before {
    background: $iv-main-color
  }
}
</style>
